import request from "@src/utils/request";

interface Address {
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  [key: string]: any;
}

interface CartDistributorProduct {
  id: string | number;
  quantity?: number;
  [key: string]: any;
}

export function getCart() {
  return request().get("/api/v1/cart/for-user/").send();
}

export async function getCartWithLivePricing() {
  return request().get("/api/v1/cart/for-user/").send();
}

export function setCartAddress(address: Address) {
  return request().post("/api/v1/cart/set-address/").send(address);
}

export function updateCartDistributorProduct(
  cartDistributorProduct: CartDistributorProduct,
) {
  return request()
    .patch(`/api/v1/cart/${cartDistributorProduct.id}/update-product-quantity/`)
    .send(cartDistributorProduct);
}

export function deleteCartDistributorProduct(
  cartDistributorProductId: string | number,
) {
  return request()
    .delete(`/api/v1/cart/${cartDistributorProductId}/remove-from-cart/`)
    .send();
}

export function addToCart(distributorProductId: string, quantity: number = 1) {
  return request()
    .post("/api/v1/cart/add-cart-product/")
    .send({ distributorProductId, quantity });
}

export function getCartCount() {
  return request().get("/api/v1/cart/count/").send();
}

export async function updateCartProductQuantity(
  cartProductId: string,
  quantity: number,
) {
  return request()
    .patch(`/api/v1/cart/${cartProductId}/update-product-quantity/`)
    .send({ quantity });
}

export async function removeCartProduct(cartProductId: string) {
  return request()
    .delete(`/api/v1/cart/${cartProductId}/remove-from-cart/`)
    .send();
}
